/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ImageSeries/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function ImageSeries({
  children,
  viewPath = "/DesignSystem/PreviewDocument/Content/Content/HtmlFile/Content/Content/Content/Actions/Upload/Content/Documents/Content/Patients/Content/Breadcrumb/ImageSeries"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let patientDocumentsSelectedImageSeriesValueData = fromData.useDataValue({ viewPath,
context: 'patient_documents',
path: 'selected_image_series',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(patientDocumentsSelectedImageSeriesValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}